module.exports = __webpack_public_path__ + "static/media/3morecoins.701c8ab9.png";